import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { useRegisterModal } from '../../contexts/RegisterModalContext';

const TelegramIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
  </svg>
);

const VKIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
    <path d="M15.684 0H8.316C1.592 0 0 1.592 0 8.316v7.368C0 22.408 1.592 24 8.316 24h7.368C22.408 24 24 22.408 24 15.684V8.316C24 1.592 22.408 0 15.684 0zm3.692 17.123h-1.744c-.66 0-.864-.525-2.05-1.727-1.033-1-1.49-1.135-1.744-1.135-.356 0-.458.102-.458.593v1.575c0 .424-.135.678-1.253.678-1.846 0-3.896-1.118-5.335-3.202C4.624 10.857 4 8.89 4 8.45c0-.254.102-.491.593-.491h1.744c.44 0 .61.203.78.677.847 2.454 2.27 4.6 2.86 4.6.22 0 .322-.102.322-.66V9.721c-.068-1.186-.695-1.287-.695-1.71 0-.203.17-.407.44-.407h2.744c.373 0 .508.203.508.643v3.473c0 .372.17.508.271.508.22 0 .407-.136.813-.542 1.27-1.422 2.18-3.61 2.18-3.61.119-.254.322-.491.763-.491h1.744c.525 0 .644.27.525.643-.22 1.017-2.354 4.031-2.354 4.031-.186.305-.254.44 0 .78.186.254.796.779 1.203 1.253.745.847 1.32 1.558 1.473 2.05.17.49-.085.744-.576.744z"/>
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
    <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"/>
  </svg>
);

const SOCIAL_LINKS = [
  { name: 'Telegram', href: 'https://t.me/', icon: TelegramIcon },
  { name: 'VK', href: 'https://vk.com/', icon: VKIcon },
  { name: 'Instagram', href: 'https://instagram.com/', icon: InstagramIcon },
];

const NAV_LINKS = [
  { labelKey: 'nav.home', to: '/' },
  { labelKey: 'nav.contests', to: '/' },
  { labelKey: 'nav.rules', to: '#' },
  { labelKey: 'nav.contacts', to: '#' },
];

export default function Footer() {
  const { t } = useLanguage();
  const { openRegister } = useRegisterModal();
  const currentYear = new Date().getFullYear();

  const handleSocialClick = (e) => {
    e.preventDefault();
    openRegister('Чтобы пользоваться функциями сайта, нужно зарегистрироваться');
  };

  return (
    <footer className="mt-auto border-t border-slate-200 bg-white/60 backdrop-blur-sm">
      <div className="px-4 xs:px-6 py-6 xs:py-8">
        {/* Main Footer Content */}
        <div className="flex flex-col tablet:flex-row tablet:items-start tablet:justify-between gap-6 xs:gap-8">
          {/* Brand */}
          <div className="flex flex-col gap-2 xs:gap-3">
            <div className="flex items-center gap-0">
              <span className="inline-flex items-center justify-center h-14 w-14 xs:h-16 xs:w-[9rem] tablet:h-[7rem] tablet:w-[10rem] -mr-[45px]">
                <img
                  src="/logo.png"
                  alt="QueenVote"
                  className="h-full w-full object-contain select-none pointer-events-none drop-shadow"
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = '/logo.svg';
                  }}
                />
              </span>
              <span className="-ml-1 text-lg xs:text-xl font-black bg-gradient-to-r from-sky-600 to-blue-700 text-transparent bg-clip-text">
                QueenVote
              </span>
            </div>
            <p className="text-xs xs:text-sm text-slate-600 max-w-xs leading-relaxed">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Social Links */}
          <div className="flex flex-col gap-2 xs:gap-3">
            <span className="text-xs xs:text-sm font-semibold text-slate-800">{t('footer.social')}</span>
            <div className="flex gap-2 xs:gap-3">
              {SOCIAL_LINKS.map((social) => {
                const IconComponent = social.icon;
                return (
                  <button
                    key={social.name}
                    type="button"
                    onClick={handleSocialClick}
                    aria-label={social.name}
                    className="w-8 h-8 xs:w-10 xs:h-10 rounded-full bg-white/70 border border-slate-200 flex items-center justify-center text-slate-600 hover:text-slate-900 hover:bg-slate-50 hover:border-slate-300 hover:scale-110 transition-all"
                  >
                    <IconComponent />
                  </button>
                );
              })}
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="w-full h-[1px] bg-gradient-to-r from-transparent via-slate-200 to-transparent my-4 xs:my-6" />

        {/* Bottom Bar */}
        <div className="flex flex-col 480:flex-row 480:items-center 480:justify-between gap-3 xs:gap-4 text-[10px] xs:text-xs text-slate-500">
          <p>{t('footer.rights', { year: currentYear })}</p>
          <div className="flex gap-3 xs:gap-4">
            <a href="#" className="hover:text-slate-900 transition-colors">
              {t('footer.privacy')}
            </a>
            <a href="#" className="hover:text-slate-900 transition-colors">
              {t('footer.terms')}
            </a>
          </div>
        </div>
      </div>

      {/* Gradient Line */}
      <div className="h-1 bg-gradient-to-r from-sky-400 via-blue-500 to-sky-400" />
    </footer>
  );
}
